
import { Ingredients } from '@/entity/entity'
import { Route } from '@/entity/route'
import Vue from 'vue'

export default Vue.extend({
  name: 'Top',
  props: {
    ingredients: {
      type: Object as () => Ingredients,
      required: true
    }
  },
  data: function () {
    return {
      listLink: Route.MenuList.path,
      howToUseLink: Route.HowToUse.path,
      publicPath: process.env.BASE_URL
    }
  }
})
